export class Holding {
    id: number = null;
    name : string = null;
    logo: string = null;
    linkedin_url: string = null;
    linkedin_tag: string = null;
    twitter_tag: string = null;
    is_independent: boolean = null;
    updated_at: string = null;
    created_at: string = null;
    history: any = null;

    constructor( id? : number|Object) {
        if (typeof(id)=='object') {
            this.import(id);
        } else {
            this.id = id;
        }
    }

    exists() {
        return !!this.id;
    }

    import(data) {
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                this[key] = data[key];
                
            }
        }
    }

};